var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _g, _path32, _path33, _path34, _path35, _g2, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopChartsDt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 121,
    viewBox: "0 0 191 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.8485 86.3232C81.8485 86.3232 84.1385 93.0885 78.25 110.31H116.526C116.526 110.31 109.656 103.544 111.291 86.3232H81.8485Z",
    fill: "#FFE4C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.066 93.0652C110.997 91.0215 111.053 88.7825 111.286 86.3232H81.8438C81.8438 86.3232 82.5322 88.3709 82.1792 93.0652H111.066Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.198 88.8476H26.9678C25.044 88.8476 23.4844 87.288 23.4844 85.3642V3.56398C23.4844 1.8836 24.8466 0.521362 26.527 0.521362H165.639C167.319 0.521362 168.681 1.8836 168.681 3.56398V85.3642C168.681 87.288 167.122 88.8476 165.198 88.8476Z",
    fill: "#FFE4C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7493 86.6595V4.65894C24.7493 3.03014 26.1547 1.70983 27.8883 1.70983H166.807C167.347 1.70983 167.848 1.84978 168.292 2.07561C167.761 1.15442 166.736 0.521362 165.542 0.521362H26.6234C24.8897 0.521362 23.4844 1.84179 23.4844 3.4706V85.4712C23.4844 86.7087 24.1952 87.7876 25.2518 88.3755C24.9346 87.8721 24.7493 87.2868 24.7493 86.6595Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.301 77.5179H29.8578C29.768 77.5179 29.6953 77.4451 29.6953 77.3555V5.84106C29.6953 5.75125 29.7681 5.67847 29.8579 5.67847H162.301C162.391 5.67847 162.464 5.75125 162.464 5.84106V77.3553C162.464 77.4451 162.391 77.5179 162.301 77.5179Z",
    fill: "#FAA64B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.304 77.5179H29.8544C29.7665 77.5179 29.6953 77.4467 29.6953 77.3588V8.79341C29.6953 8.70539 29.7667 8.63416 29.8546 8.63416H162.304C162.392 8.63416 162.464 8.70551 162.464 8.79341V77.3587C162.464 77.4467 162.392 77.5179 162.304 77.5179Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7876 109.52L55.6797 120.104H134.848L131.74 109.52H58.7876Z",
    fill: "#FFE4C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.167 82.9941C100.167 84.5451 98.9264 85.8024 97.3959 85.8024C95.8656 85.8024 94.625 84.5451 94.625 82.9941C94.625 81.443 95.8656 80.1856 97.3959 80.1856C98.9264 80.1856 100.167 81.443 100.167 82.9941Z",
    fill: "#F48000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.156 14.7673C72.156 14.0748 71.5946 13.5134 70.9021 13.5134H23.4844V60.2553H70.9021C71.5947 60.2553 72.156 59.6939 72.156 59.0014V14.7673Z",
    fill: "#231F20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.674 24.7104H124.373C123.382 24.7104 122.578 25.5142 122.578 26.5055V61.2963C122.578 62.2878 123.382 63.0914 124.373 63.0914H168.674V24.7104Z",
    fill: "#231F20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M113.55 12.1273H80.5939C78.6478 12.1273 77.0703 13.7049 77.0703 15.651V67.4692C77.0703 69.4153 78.6478 70.9928 80.5939 70.9928H113.55C115.496 70.9928 117.074 69.4152 117.074 67.4692V15.6509C117.074 13.7049 115.496 12.1273 113.55 12.1273Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3493 16.6685H1.35553C0.663039 16.6685 0.101562 17.2298 0.101562 17.9223V62.1564C0.101562 62.8489 0.663039 63.4104 1.35553 63.4104H67.3493C68.0418 63.4104 68.6031 62.8489 68.6031 62.1564V17.9224C68.6031 17.2298 68.0418 16.6685 67.3493 16.6685Z",
    fill: "#F4F4F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6893 49.1935H11.06C11.0183 49.1935 10.9844 49.1597 10.9844 49.1179V48.1398C10.9844 48.0981 11.0182 48.0643 11.0599 48.0643H23.6893C23.731 48.0643 23.7648 48.0981 23.7648 48.1399V49.118C23.7649 49.1596 23.7311 49.1935 23.6893 49.1935Z",
    fill: "#FFD2A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57804 50.1817H5.64357C5.58151 50.1817 5.53125 50.1315 5.53125 50.0694V47.1883C5.53125 47.1262 5.58163 47.0759 5.64369 47.0759H8.57816C8.64021 47.0759 8.69048 47.1261 8.69048 47.1882V50.0693C8.69048 50.1313 8.64009 50.1817 8.57804 50.1817Z",
    fill: "#FFD2A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6893 53.711H11.06C11.0182 53.711 10.9844 53.6772 10.9844 53.6354V52.6572C10.9844 52.6155 11.0182 52.5817 11.06 52.5817H23.6894C23.7311 52.5817 23.7649 52.6155 23.7649 52.6572V53.6354C23.7649 53.6771 23.7311 53.711 23.6893 53.711Z",
    fill: "#FFD2A0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57816 54.6991H5.64369C5.58163 54.6991 5.53125 54.6487 5.53125 54.5867V51.7057C5.53125 51.6436 5.58163 51.5933 5.64369 51.5933H8.57804C8.6401 51.5933 8.69036 51.6435 8.69036 51.7056V54.5867C8.6906 54.6489 8.64021 54.6991 8.57816 54.6991Z",
    fill: "#FFD2A0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6893 58.2284H11.06C11.0183 58.2284 10.9844 58.1946 10.9844 58.1528V57.1747C10.9844 57.1329 11.0182 57.0991 11.06 57.0991H23.6893C23.731 57.0991 23.7648 57.1329 23.7648 57.1747V58.1528C23.7649 58.1946 23.7311 58.2284 23.6893 58.2284Z",
    fill: "#FFD2A0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57828 59.2166H5.64369C5.58163 59.2166 5.53125 59.1663 5.53125 59.1041V56.2233C5.53125 56.1612 5.58163 56.1108 5.64369 56.1108H8.57816C8.64021 56.1108 8.69048 56.1611 8.69048 56.2231V59.1042C8.6906 59.1663 8.64033 59.2166 8.57828 59.2166Z",
    fill: "#FFD2A0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8673 49.9069H31.7583C31.6631 49.9069 31.5859 49.8298 31.5859 49.7346V48.4521C31.5859 48.3571 31.663 48.2799 31.7582 48.2799H44.8673C44.9625 48.2799 45.0396 48.357 45.0396 48.4521V49.7347C45.0395 49.8298 44.9624 49.9069 44.8673 49.9069Z",
    fill: "#FFD2A0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1966 53.646H31.7664C31.6667 53.646 31.5859 53.5653 31.5859 53.4656V52.2067C31.5859 52.1071 31.6667 52.0264 31.7663 52.0264H62.1966C62.2962 52.0264 62.377 52.1071 62.377 52.2067V53.4656C62.3771 53.5651 62.2962 53.646 62.1966 53.646Z",
    fill: "#FFD2A0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5054 57.5808H31.7135C31.6431 57.5808 31.5859 57.5237 31.5859 57.4532V56.2138C31.5859 56.1434 31.643 56.0863 31.7134 56.0863H51.5054C51.5758 56.0863 51.6328 56.1434 51.6328 56.2138V57.4533C51.6328 57.5237 51.5758 57.5808 51.5054 57.5808Z",
    fill: "#FFD2A0"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0867 34.9921H33.2422V42.0179H38.0867V34.9921Z",
    fill: "#F48000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4382 35.4591H31.5938V42.0179H36.4382V35.4591Z",
    fill: "#F48000"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5938 35.459L33.2385 34.9921H38.083L36.4384 35.459H31.5938Z",
    fill: "#FFD2A0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1726 30.2633H42.3281V42.0181H47.1726V30.2633Z",
    fill: "#F48000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M45.532 30.7301H40.6875V42.0181H45.532V30.7301Z",
    fill: "#F48000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6875 30.73L42.3323 30.2633H47.1768L45.532 30.73H40.6875Z",
    fill: "#FFD2A0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8757 27.5819H51.0312V42.0179H55.8757V27.5819Z",
    fill: "#F48000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2274 28.0486H49.3828V42.0178H54.2274V28.0486Z",
    fill: "#F48000"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3828 28.0487L51.0276 27.5819H55.8721L54.2273 28.0487H49.3828Z",
    fill: "#FFD2A0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3289 42.0181H59.4844L59.5396 24.0596H64.3841L64.3289 42.0181Z",
    fill: "#F48000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6803 42.018H57.8359L57.8911 24.5263H62.7357L62.6803 42.018Z",
    fill: "#F48000"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8828 24.5264L59.5276 24.0596H64.3721L62.7274 24.5264H57.8828Z",
    fill: "#FFD2A0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1373 41.9775C9.05218 41.9775 4.10156 37.0271 4.10156 30.9418C4.10156 24.8564 9.0523 19.906 15.1373 19.906C21.2224 19.906 26.173 24.8564 26.173 30.9418C26.173 37.0271 21.2224 41.9775 15.1373 41.9775ZM15.1373 20.924C9.61342 20.924 5.1197 25.4181 5.1197 30.9416C5.1197 36.4653 9.61353 40.9592 15.1373 40.9592C20.6612 40.9592 25.1549 36.4652 25.1549 30.9416C25.155 25.4181 20.6612 20.924 15.1373 20.924Z",
    fill: "#FFD2A0"
  }))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1386 19.397V21.4333C20.3815 21.4333 24.6471 25.6986 24.6471 30.9418C24.6471 36.1851 20.3815 40.4503 15.1386 40.4503C9.89565 40.4503 5.63002 36.1851 5.63002 30.9419H3.59375C3.59387 37.3076 8.77293 42.4866 15.1386 42.4866C21.5043 42.4866 26.6834 37.3075 26.6834 30.9418C26.6834 24.576 21.5043 19.397 15.1386 19.397Z",
    fill: "#F48000"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9946 29.4164V29.6887L11.6663 32.4673H11.2392L12.5629 29.7686V29.7592H11.0703V29.4165L12.9946 29.4164Z",
    fill: "#F4F4FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2415 29.7636H14.0774L13.9601 30.5474C14.0305 30.538 14.0962 30.5286 14.2088 30.5286C14.4434 30.5286 14.6782 30.5803 14.8659 30.6929C15.1052 30.829 15.3025 31.0918 15.3025 31.4767C15.3025 32.0727 14.8284 32.5186 14.1666 32.5186C13.8334 32.5186 13.5517 32.4247 13.4062 32.3308L13.5095 32.0163C13.6362 32.0914 13.8851 32.1853 14.1619 32.1853C14.5515 32.1853 14.8847 31.9318 14.8847 31.5235C14.8801 31.1293 14.6172 30.8477 14.007 30.8477C13.8334 30.8477 13.6974 30.8664 13.5847 30.8806L13.7818 29.416H15.2415V29.7636Z",
    fill: "#F4F4FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2034 30.2753C17.2034 30.9183 16.8655 31.2375 16.4713 31.2375C16.0911 31.2375 15.7625 30.9323 15.7578 30.3175C15.7578 29.7074 16.0911 29.3648 16.4946 29.3648C16.9219 29.3648 17.2034 29.6933 17.2034 30.2753ZM16.0863 30.3034C16.0769 30.6929 16.2225 30.9887 16.4806 30.9887C16.7528 30.9887 16.8749 30.6977 16.8749 30.294C16.8749 29.9233 16.7669 29.6135 16.4806 29.6135C16.2225 29.6133 16.0863 29.9185 16.0863 30.3034ZM16.443 32.5187L18.236 29.3648H18.4989L16.7059 32.5187H16.443ZM19.1888 31.5379C19.1888 32.181 18.8509 32.5 18.4613 32.5C18.081 32.5 17.7525 32.1949 17.7479 31.5847C17.7479 30.9699 18.0811 30.6272 18.4848 30.6272C18.9119 30.6273 19.1888 30.9558 19.1888 31.5379ZM18.0717 31.566C18.067 31.9555 18.2172 32.2512 18.4706 32.2512C18.7429 32.2512 18.8649 31.9602 18.8649 31.5566C18.8649 31.1858 18.757 30.876 18.4706 30.876C18.2125 30.876 18.0717 31.1812 18.0717 31.566Z",
    fill: "#F4F4FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4454_56734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.204 66.2465H120.826C119.835 66.2465 119.031 65.4427 119.031 64.4514V29.6606C119.031 28.6691 119.835 27.8655 120.826 27.8655H185.204C186.195 27.8655 186.999 28.6692 186.999 29.6606V64.4514C186.999 65.4427 186.195 66.2465 185.204 66.2465Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.501 50.1089H126.836V58.5928H128.501V50.1089Z",
    fill: "#FFD2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.103 39.2471H130.438V58.5927H132.103V39.2471Z",
    fill: "#F48000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72 46.2527H134.055V58.5928H135.72V46.2527Z",
    fill: "#FFE4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.946 39.2471H141.281V58.5926H142.946V39.2471Z",
    fill: "#FFD2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.548 50.1089H144.883V58.5927H146.548V50.1089Z",
    fill: "#F48000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.165 46.2527H148.5V58.5928H150.165V46.2527Z",
    fill: "#FFE4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.368 46.2528H155.703V58.5929H157.368V46.2528Z",
    fill: "#FFD2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.97 39.2471H159.305V58.5927H160.97V39.2471Z",
    fill: "#F48000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.587 35.5195H162.922V58.5928H164.587V35.5195Z",
    fill: "#FFE4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.806 42.7298H170.141V58.5927H171.806V42.7298Z",
    fill: "#FFD2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.407 38.7329H173.742V58.5927H175.407V38.7329Z",
    fill: "#F48000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.025 46.2527H177.359V58.5928H179.025V46.2527Z",
    fill: "#FFE4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.672 58.0143H124.359V58.9223H181.672V58.0143Z",
    fill: "#62729B"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M110.003 74.1477H77.047C75.101 74.1477 73.5234 72.5701 73.5234 70.6241V18.8059C73.5234 16.8598 75.101 15.2822 77.047 15.2822H110.003C111.95 15.2822 113.527 16.8598 113.527 18.8059V70.6241C113.527 72.5701 111.949 74.1477 110.003 74.1477Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0599 57.8771H79.0969C78.9959 57.8771 78.9141 57.7953 78.9141 57.6943V56.0605C78.9141 55.9596 78.9959 55.8777 79.0968 55.8777H91.0598C91.1608 55.8777 91.2425 55.9596 91.2425 56.0605V57.6944C91.2426 57.7954 91.1608 57.8771 91.0599 57.8771Z",
    fill: "#FFD2A0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.939 62.4719H79.1056C78.9998 62.4719 78.9141 62.3862 78.9141 62.2804V60.6729C78.9141 60.5671 78.9997 60.4815 79.1055 60.4815H106.939C107.045 60.4815 107.13 60.5671 107.13 60.6729V62.2804C107.13 62.3863 107.045 62.4719 106.939 62.4719Z",
    fill: "#FFD2A0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1492 67.3078H79.0494C78.9747 67.3078 78.9141 67.2471 78.9141 67.1725V65.6063C78.9141 65.5316 78.9746 65.4711 79.0493 65.4711H97.1493C97.224 65.4711 97.2845 65.5316 97.2845 65.6063V67.1725C97.2845 67.2471 97.2239 67.3078 97.1492 67.3078Z",
    fill: "#FFD2A0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M103.262 46.8958C108.834 41.3233 108.834 32.2885 103.262 26.716C97.6894 21.1435 88.6546 21.1435 83.0821 26.716C77.5096 32.2885 77.5096 41.3233 83.0821 46.8958C88.6546 52.4683 97.6894 52.4683 103.262 46.8958Z",
    fill: "#FDB515"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M107.441 36.8062C107.441 28.9254 101.053 22.5367 93.1719 22.5367V51.0756C101.053 51.0754 107.441 44.6868 107.441 36.8062Z",
    fill: "#8192C3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9062 36.8061C78.9062 37.153 78.923 37.4958 78.9473 37.8365L93.1757 36.8061V22.5366C85.2949 22.5366 78.9062 28.9252 78.9062 36.8061Z",
    fill: "#373069"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.972 48.0341L93.1719 36.806V51.0754C96.4936 51.0754 99.5475 49.9374 101.972 48.0341Z",
    fill: "#EAE8EB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M103.354 47.0977C108.966 41.4853 108.966 32.3857 103.354 26.7733C97.7413 21.1608 88.6418 21.1608 83.0293 26.7732C77.4169 32.3856 77.417 41.4851 83.0294 47.0976C88.6419 52.71 97.7414 52.7101 103.354 47.0977Z",
    fill: "#FFD2A0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M107.567 36.9355C107.567 28.9982 101.133 22.5638 93.1953 22.5638V51.3071C101.133 51.3072 107.567 44.8727 107.567 36.9355Z",
    fill: "#F48000"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8281 36.9355C78.8281 37.2848 78.845 37.6301 78.8695 37.9733L93.1997 36.9355V22.5639C85.2625 22.5639 78.8281 28.9982 78.8281 36.9355Z",
    fill: "#FFE4C6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M102.059 48.2441L93.1953 36.9356V51.3073C96.5408 51.3072 99.6167 50.1609 102.059 48.2441Z",
    fill: "#FAA64B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4454_56734",
    x: 115.031,
    y: 24.8655,
    width: 75.9688,
    height: 46.381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4454_56734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4454_56734",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopChartsDt);
export default __webpack_public_path__ + "static/media/laptop_charts_DT.6298e2f6d2c8edc3695b1e1462ce7e81.svg";
export { ForwardRef as ReactComponent };